import { getBDNotes, addBDNotes, updateBDNotes, getBDNoteComments, addBDNoteComment, updateBDNoteComment } from '@/api/bdnote'

const bdnote = {
  state: {
    total: 0,
    rows: []
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    }
  },
  actions: {
    // 获取BD Note
    GetBDNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBDNotes(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 新增BD Note
    AddBDNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        addBDNotes(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改BD Note
    UpdateBDNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBDNotes(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查看BD Note Comments
    GetBDNoteComments({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBDNoteComments(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 新增BD Note Comment
    AddBDNoteComment({ commit }, params) {
      return new Promise((resolve, reject) => {
        addBDNoteComment(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改BD Note Comment
    UpdateBDNoteComment({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBDNoteComment(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default bdnote



// WEBPACK FOOTER //
// ./src/store/modules/bdnote.js